export const maxPercent = value => (value > 1 ? 1 : value);
